let accordeon = {};

export const addTransition = (
	elm,
	targetElm,
	intervalTime = 500,
	timeoutTime = 1000
) => {
	clearTransition(elm);

	let intervalId = setInterval(() => {
		resizeElement(elm, targetElm);
	}, intervalTime);

	const timeoutId = setTimeout(() => {
		clearTransition(elm);
	}, timeoutTime);

	accordeon[elm.id] = {
		intervalId,
		timeoutId,
	};
};

export const clearTransition = (elm) => {
	if (elm.id in accordeon) {
		clearInterval(accordeon[elm.id].intervalId);
		clearTimeout(accordeon[elm.id].timeoutId);
	}
};

export const resizeElement = (activeElm, accordeonElm) => {
	if (activeElm.classList.contains('active')) {
		const accordionHeight = accordeonElm.scrollHeight;
		accordeonElm.style.maxHeight = `${accordionHeight}px`;
	}
};
